import Vue from 'vue'
import App from './App.vue'
import store from './store'

import { BootstrapVue, IconsPlugin, ButtonGroupPlugin, InputGroupPlugin, LayoutPlugin, SidebarPlugin } from 'bootstrap-vue';

//import 'popper.js';

import jQuery from 'jquery';
import VueRouter from 'vue-router'

import axios from 'axios';
import VueAxios from 'vue-axios';
import VueToast from 'vue-toast-notification';
//import VueSweetalert2 from 'vue-sweetalert2';
import Dialog from 'bootstrap-vue-dialog/dist/bootstrap-vue-dialog'



import * as VueGoogleMaps from "vue2-google-maps";


Vue.use(jQuery)
Vue.use(VueRouter)
Vue.use(BootstrapVue)
Vue.use(VueAxios, axios);
Vue.use(VueToast)
Vue.use(IconsPlugin)
Vue.use(ButtonGroupPlugin)
Vue.use(InputGroupPlugin)
Vue.use(LayoutPlugin)
Vue.use(SidebarPlugin)
Vue.use(Dialog)
//Vue.use(VueSweetalert2);

//Vue.component('b-toast', BToast)

let map_key = ""
map_key = "AIzaSyAI8Rw6GubVmklVABUiHqwq1XqCwPxiAVg" //tmbill
// map_key = "AIzaSyCeVT1qiYm5isnYb4eyLhfsxyI29VvP-vI" //ariose
// map_key = "AIzaSyBxp66FJgFLwkpiy4UbTAQjYENWVJ__xdE" // Vaibhav Test API
// map_key = "AIzaSyA-iC3nd_RNwXWsKG0I83aYysBIJlXQnRY" //bowls n boxes
//map_key = "AIzaSyCs6VRK3L7Ep87yU8PkoQl_r_MUuWJLC5k" //The Isha foods
//map_key = "AIzaSyA32ZAKMa4F-PXjBkeQICJg-bg-qBLPbHY" //puchkawale

// map_key = "AIzaSyDlMbtdaPRFdbTtSA1gCqNjpwkY5aA_h9w"

// map_key = "AIzaSyDQ0up_kqWSydl6FwypyTLYreEOY7dvu0M" //grillfry 

//google_map_key add here for new customer 


Vue.use(VueGoogleMaps, {
    load: {
        key: map_key,
        libraries: "places," //necessary for places input
    }
});


import './assets/css/bootstrap.css'
import './assets/css/style.css'
import './assets/css/newstyle.css'
import './assets/css/responsive.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'




window.$ = window.jQuery = jQuery;


Vue.config.productionTip = false

import routes from './router/index'


import { Datetime } from 'vue-datetime'

import 'vue-datetime/dist/vue-datetime.css'

Vue.use(Datetime)


// Require dependencies
//var Vue = require('vue');
var VueCookie = require('vue-cookie');
// Tell Vue to use the plugin
Vue.use(VueCookie);

axios.defaults.baseURL = "https://api.tmbill.com/digimenu/tmdigi-menu/api/"

const router = new VueRouter({ routes });

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')